import React from 'react'
import { AppModalBox } from 'components/Common/AppModalBox/AppModalBox.component'
import { AppButton } from 'components/Common/AppButton/AppButton.component'
import { AppBinWarningIcon } from 'components/Common/AppSvgIcons/AppBinWarningIcon'
import { formatMessageTextPlain } from 'components/Chat/helper/messageFormatter'
import { renderText } from 'stream-chat-react'

interface DeleteMessageModalProps {
  show: boolean
  message: any
  onCancel: () => void
  onConfirm: () => void
}

// Note: formatMessageTextPlain is now imported from helper/messageFormatter

export const DeleteMessageModal: React.FC<DeleteMessageModalProps> = ({
  show,
  message,
  onCancel,
  onConfirm,
}) => {
  if (!show) return null

  // Format the message text for display using the helper function
  const formattedText = message?.text ? formatMessageTextPlain(message.text) : ''

  return (
    <AppModalBox
      onClose={onCancel}
      width="w-[500px]"
      backgroundColor="bg-white"
      childClass="p-6"
      showCancelButton={false}
      margin=""
      height="h-auto"
      isOnBoarding={false}
      padding="p-6"
      position="center"
      rounded="xl"
      showBorder={false}
    >
      <div className="text-center">
        {/* Delete Icon */}
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
          <div className="flex items-center justify-center h-12 w-12">
            <div className="bg-app-red-25 rounded-xl p-2">
              <AppBinWarningIcon />
            </div>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-md font-semibold text-app-black-100 mb-3">Delete Message?</h3>

        {/* Description */}
        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to delete this message? This cannot be undone.
        </p>

        {/* Message Preview */}
        {formattedText && (
          <div className="bg-app-primary-60 rounded-lg p-4 mb-6 text-left shadow-sm">
            <div className="text-sm text-white leading-relaxed break-words">
              {renderText(formattedText)}
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex gap-3 justify-end">
          <AppButton size="md" variant="alert" label="Delete message" onClick={onConfirm} />
        </div>
      </div>
    </AppModalBox>
  )
}
